import { render, staticRenderFns } from "./areaFitBase.vue?vue&type=template&id=47cb3780&scoped=true&"
import script from "./areaFitBase.vue?vue&type=script&lang=js&"
export * from "./areaFitBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb3780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47cb3780')) {
      api.createRecord('47cb3780', component.options)
    } else {
      api.reload('47cb3780', component.options)
    }
    module.hot.accept("./areaFitBase.vue?vue&type=template&id=47cb3780&scoped=true&", function () {
      api.rerender('47cb3780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaFit/areaFitBase.vue"
export default component.exports